<div class="main-content page-container bg-gray-100">
  <div class="side-bar w-1/5 bg-gray-50 pt-10 pe-8">
    <div class="mb-8">
      <div class="w-fit border-sm-full {{corBordaTitulo}} rounded-xl py-1 px-3">
        <span class="{{corTextoTitulo}} text-body-md font-regular flex text-center">
          {{tituloResultado}}
        </span>
      </div>
    </div>

    <div class="ilustration-container flex gap-4">
      <img [src]="imagemFundo" alt="ilustration">

      <div class="flex flex-col justify-between">
        <div>
          <span class="text-charcoal-800 text-body-lg">{{redeSelecionada}}</span>
          <span class="text-charcoal-800 text-body-lg"> /</span>
          <br>
          <span class="text-charcoal-800 text-body-lg">{{pais}} </span>
          <span class="text-charcoal-800 text-body-lg">/ </span>
          <span class="text-charcoal-800 text-body-lg">{{estado}}</span>
        </div>

        <div>
          <span class="text-blue-500 text-heading-sm text-bold">{{cidade}} {{ano}}</span>
        </div>
      </div>
    </div>

    <div class="resultados-wrapper">
      <h1 class="text-charcoal-800 text-heading-md font-bold m-0 mb-2">Resultados</h1>
      <p class="text-charcoal-800 text-body-lg font-regular m-0">Resultados das projeções do SimCAQ para a localidade</p>
    </div>

    <div class="actions-container flex flex-col gap-6 mt-8">
      <div *ngIf="rotaFiltroLocalidade != ''" routerLink="{{rotaFiltroLocalidade}}" class="action flex gap-2 items-center">
        <img src="assets/icons/localizacao.svg" alt="location" class="icon w-4 h-4">
        <span class="text-charcoal-600 text-body-lg font-regular">Alterar localidade</span>
      </div>
      <div *ngIf="rotaIndicadoresLocais != ''" routerLink="{{rotaIndicadoresLocais}}" class="action flex gap-2 items-center">
        <img src="assets/icons/half-pizza.svg" alt="location" class="icon w-4 h-4">
        <span class="text-charcoal-600 text-body-lg font-regular">Conheça os indicadores locais</span>
      </div>
      <ng-container *ngIf="downloads as links">
        <ng-container *ngIf="links.length > 0">
          <div class=" flex gap-2 items-center">
            <img src="assets/icons/download.svg" alt="download" class="icon w-4 h-4">
            <span class="text-charcoal-600 text-body-lg font-bold">Downloads dos Resultados</span>
          </div>

          <div *ngFor="let link of links" class="ms-6">
            <a *ngIf="link.tipo === 'rota'" [href]="urlBase + '/' + link.rota" class="action flex text-charcoal-600 text-body-lg font-regular"
              style="text-decoration: none;">
              {{ link.texto }}
            </a>
            <a *ngIf="link.tipo === 'acao'" (click)="link.acao()" class="action flex text-charcoal-600 text-body-lg font-regular"
              style="text-decoration: none;">
              {{ link.texto }}
            </a>
          </div>
        </ng-container>
      </ng-container>
      <div *ngIf="editavel" (click)="abrirEdicaoSimulacao()" class="action flex gap-2 items-center">
        <img src="assets/icons/pen.svg" alt="location" class="icon w-4 h-4">
        <span class="text-red-500 text-body-lg font-regular">Editar parâmetros da simulação</span>
      </div>
      <div routerLink="{{rotaApresentacao}}" class="action flex gap-2 items-center">
        <img src="assets/icons/casa.svg" alt="location" class="icon w-4 h-4">
        <span class="text-charcoal-600 text-body-lg font-regular">Voltar ao início</span>
      </div>
    </div>
  </div>

  <div class="content w-4/5 pt-12 pb-30">
    <router-outlet></router-outlet>
       <div class="w-full {{corTextoRodape}} mt-16 text-bold text-heading-md">
      Como citar esta página?
    </div>
    <div class="divCite w-full pt-4">
    <div class="textoComoCitar w-full text-body-lg text-charcoal-600 p-2 rounded-tl-xs rounded-bl-xs">{{ textoComoCitar }}</div>
    <div>
      <button class="buttonCopy {{corBotaoRodape}} rounded-tr-xs rounded-br-xs border-sm-full {{corBordaBotaoRodape}}"
        (click)="copiarParaAreaDeTransferencia()">
          <img alt="rows" src="../../../assets/imagens/copy.svg">
          <span class="text-body-lg text-regular text-gray-50">Copiar</span>
      </button>
    </div>
  </div>
</div>
